import isEqual from 'lodash/isEqual'
import { useFormikContext } from 'formik'
import { useDebounce } from './useDebounce'
import { useEffect, useState, useCallback } from 'react'

export function SubmitListener(): null {
  const formik = useFormikContext<unknown>()
  const [lastValues, updateState] = useState(formik.values)
  const [debounce, clearDebounce] = useDebounce()

  const debouncedSubmit = useCallback(() => {
    clearDebounce()
    debounce(formik.submitForm)
  }, [clearDebounce, debounce, formik])

  useEffect(() => {
    const valuesEqualLastValues = isEqual(lastValues, formik.values)
    const valuesEqualInitialValues = isEqual(
      formik.values,
      formik.initialValues
    )

    if (!valuesEqualLastValues) {
      updateState(formik.values)
    }

    if (!valuesEqualLastValues && !valuesEqualInitialValues && formik.isValid) {
      debouncedSubmit()
    }
  }, [
    formik.values,
    formik.isValid,
    lastValues,
    formik.initialValues,
    debouncedSubmit,
  ])

  useEffect(() => {
    return clearDebounce
  }, [clearDebounce])

  return null
}
